import React from "react";
import styled from "styled-components";

// color - red | green | yellow
// size - sm | md | lg

const Chip = ({ color, children, size = "sm", text, className, disabled }) => {
  return (
    <ChipContainer
      color={color?.toLowerCase()}
      size={size?.toLowerCase()}
      className={className}
      disabled={disabled}
    >
      {children ?? text}
    </ChipContainer>
  );
};

export default Chip;

const ChipContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  max-width: 100%;
  font-size: ${({ size }) => {
    if (size === "sm") return "12px";
    if (size === "md") return "14px";
    if (size === "lg") return "18px";
  }} !important;
  line-height: ${({ size }) => {
    if (size === "sm") return "16px";
    if (size === "md") return "18px";
    if (size === "lg") return "24px";
  }};
  padding: ${({ size }) => {
    if (size === "sm") return "2px 4px";
    if (size === "md") return "4px 8px";
    if (size === "lg") return "8px 12px";
  }};
  border: 1px solid
    ${({ color, disabled }) => {
      if (disabled) return "#A6A6A6";
      if (color === "red") return "#C54600";
      if (color === "green") return "#108145";
      if (color === "yellow") return "#8B8000";
    }};
  color: ${({ color, disabled }) => {
    if (disabled) return "#727272";
    if (color === "red") return "#C54600";
    if (color === "green") return "#108145";
    if (color === "yellow") return "#8B8000";
  }};
  background-color: ${({ color, disabled }) => {
    if (disabled) return "#E8E8E8";
    if (color === "red") return "#FEE2D4";
    if (color === "green") return "#D8F5DF";
    if (color === "yellow") return "#FFF3CD";
  }};
  border-radius: ${({ size }) => {
    if (size === "sm") return "4px";
    if (size === "md") return "6px";
    if (size === "lg") return "8px";
  }};
`;
